export default __webpack_public_path__ + "static/national-yards-mobile-a7ddfbb387e8e41f7db35f7cf8906a84.svg";